import React from 'react';
import { Box, Inscription, useResponsive } from '@common-fe/common-fe';

interface Props {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  descriptionLineHeight?: string;
}

const CardActionCardHeader: React.FC<Props> = ({
  icon,
  title,
  description,
  descriptionLineHeight = '22px',
}) => {
  const { isMobile } = useResponsive();

  if (isMobile) {
    return (
      <Box direction="row" align="center" gap="spacing12" margin={{ bottom: 'spacing24' }}>
        {icon}
        <Box>
          <Inscription
            color="textBody"
            weight="bold"
            lineHeight="20px"
          >
            {title}
          </Inscription>
          <Inscription
            color="textBody"
            lineHeight={descriptionLineHeight}
          >
            {description}
          </Inscription>
        </Box>
      </Box>
    );
  }

  return (
    <Box align="center" margin={{ bottom: 'spacing16' }}>
      {icon}
      <Box margin={{ top: 'spacing16', bottom: 'spacing8' }}>
        <Inscription
          color="textBody"
          weight="bold"
          lineHeight="20px"
        >
          {title}
        </Inscription>
      </Box>
      <Inscription
        color="textBody"
        textAlign="center"
        lineHeight={descriptionLineHeight}
      >
        {description}
      </Inscription>
    </Box>
  );
};

export default CardActionCardHeader;
